(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function () {
    if (window.__aecAeroModularInit) {
      return;
    }

    window.__aecAeroModularInit = true;

    var hero = document.querySelector('.aec-aero-section .aec-aero-hero-grid');
    var navShell = document.querySelector('.aec-aero-nav-shell');
    var navLinks = Array.prototype.slice.call(document.querySelectorAll('.aec-aero-nav-link[href^="#"]'));
    var currentLabel = document.querySelector('[data-aero-current-label]');
    var progressBar = document.querySelector('[data-aero-progress]');
    var revealTargets = Array.prototype.slice.call(document.querySelectorAll(
      '.aec-aero-head, .aec-aero-highlight-card, .aec-aero-story, .aec-aero-tech-grid, .aec-aero-product-card, .aec-aero-compare, .aec-aero-faq-item, .aec-aero-cta-grid'
    ));
    var inViewTargets = Array.prototype.slice.call(document.querySelectorAll(
      '.aec-aero-highlight-card, .aec-aero-story, .aec-aero-tech-card, .aec-aero-faq-item, .aec-aero-selection-summary, .aec-aero-compare-table'
    ));
    var compareSection = document.querySelector('#compare');
    var compareTable = document.querySelector('[data-aero-compare-table]');
    var compareFocusNote = document.querySelector('[data-aero-compare-focus-note]');
    var compareFocusTitle = document.querySelector('[data-aero-compare-focus-title]');
    var compareFocusText = document.querySelector('[data-aero-compare-focus-text]');
    var compareFocusPrice = document.querySelector('[data-aero-compare-focus-price]');
    var compareFocusChips = document.querySelector('[data-aero-compare-focus-chips]');
    var compareFocusLink = document.querySelector('[data-aero-compare-focus-link]');
    var compareFocusLinkText = document.querySelector('[data-aero-compare-focus-link-text]');
    var compareColumns = Array.prototype.slice.call(document.querySelectorAll('[data-aero-compare-column]'));
    var productCards = Array.prototype.slice.call(document.querySelectorAll('[data-aero-product-card]'));
    var productGrid = document.querySelector('[data-aero-product-grid]');
    var modelSelectors = Array.prototype.slice.call(document.querySelectorAll('[data-aero-model-selector]'));
    var compareSelectors = Array.prototype.slice.call(document.querySelectorAll('[data-aero-compare-selector]'));
    var faqItems = Array.prototype.slice.call(document.querySelectorAll('.aec-aero-faq-item'));
    var selectionModel = document.querySelector('[data-aero-selection-model]');
    var selectionTitle = document.querySelector('[data-aero-selection-title]');
    var selectionText = document.querySelector('[data-aero-selection-text]');
    var selectionChips = document.querySelector('[data-aero-selection-chips]');
    var selectionIndex = document.querySelector('[data-aero-selection-index]');
    var mobileBuybar = document.querySelector('[data-aero-mobile-buybar]');
    var mobileBuybarLabel = document.querySelector('[data-aero-mobile-buybar-label]');
    var mobileBuybarTitle = document.querySelector('[data-aero-mobile-buybar-title]');
    var mobileBuybarPrice = document.querySelector('[data-aero-mobile-buybar-price]');
    var mobileBuybarButton = document.querySelector('[data-aero-mobile-buybar-button]');
    var mobileBuybarButtonText = document.querySelector('[data-aero-mobile-buybar-button-text]');
    var currentActiveId = null;
    var activeProductIndex = 0;
    var navTargets = navLinks
      .map(function (link) {
        try {
          return document.querySelector(link.getAttribute('href'));
        } catch (error) {
          return null;
        }
      })
      .filter(Boolean);

    function setCompareSpotlight(index) {
      compareColumns.forEach(function (cell) {
        var isMatch = Number(cell.getAttribute('data-aero-compare-column')) === index;
        cell.classList.toggle('is-spotlight', isMatch);
      });

      if (compareSection) {
        compareSection.classList.toggle('has-spotlight', index !== null && index !== undefined);
      }
    }

    function getProductCardByIndex(index) {
      return productCards.find(function (card) {
        return Number(card.getAttribute('data-aero-model-index')) === index;
      });
    }

    function clearCompareSpotlight() {
      setCompareSpotlight(null);
    }

    function syncSelectorState(index) {
      modelSelectors.forEach(function (selector) {
        var isMatch = Number(selector.getAttribute('data-aero-model-index')) === index;
        selector.classList.toggle('is-selected', isMatch);
      });

      compareSelectors.forEach(function (selector) {
        var isMatch = Number(selector.getAttribute('data-aero-model-index')) === index;
        selector.classList.toggle('is-selected', isMatch);
      });
    }

    function syncProductCardState(index) {
      productCards.forEach(function (card) {
        var isMatch = Number(card.getAttribute('data-aero-model-index')) === index;
        card.classList.toggle('is-selected', isMatch);
      });
    }

    function updateSelectionSummary(index) {
      if (!selectionTitle && !selectionText && !selectionChips) {
        return;
      }

      var activeCard = getProductCardByIndex(index);

      if (!activeCard) {
        return;
      }

      if (selectionModel) {
        selectionModel.textContent = activeCard.getAttribute('data-aero-model-title') || '';
      }

      if (selectionIndex) {
        selectionIndex.textContent = String(index + 1).padStart(2, '0');
      }

      if (selectionTitle) {
        selectionTitle.textContent = activeCard.getAttribute('data-aero-selection-title') || '';
      }

      if (selectionText) {
        selectionText.textContent = activeCard.getAttribute('data-aero-selection-text') || '';
      }

      if (selectionChips) {
        selectionChips.innerHTML = '';
        [1, 2, 3].forEach(function (chipIndex) {
          var value = activeCard.getAttribute('data-aero-selection-chip-' + chipIndex);
          if (!value) {
            return;
          }

          var chip = document.createElement('span');
          chip.className = 'aec-aero-selection-chip';
          chip.textContent = value;
          selectionChips.appendChild(chip);
        });
      }
    }

    function updateCompareFocus(index) {
      if (
        !compareFocusTitle &&
        !compareFocusText &&
        !compareFocusPrice &&
        !compareFocusChips &&
        !compareFocusLink
      ) {
        return;
      }

      var activeCard = getProductCardByIndex(index);
      if (!activeCard) {
        return;
      }

      if (compareFocusNote) {
        compareFocusNote.textContent = activeCard.getAttribute('data-aero-model-eyebrow') || '';
      }

      if (compareFocusTitle) {
        compareFocusTitle.textContent = activeCard.getAttribute('data-aero-model-title') || '';
      }

      if (compareFocusText) {
        compareFocusText.textContent =
          activeCard.getAttribute('data-aero-selection-text') ||
          activeCard.getAttribute('data-aero-product-summary') ||
          '';
      }

      if (compareFocusPrice) {
        compareFocusPrice.textContent = activeCard.getAttribute('data-aero-product-price') || '';
      }

      if (compareFocusChips) {
        compareFocusChips.innerHTML = '';
        [1, 2, 3].forEach(function (chipIndex) {
          var value = activeCard.getAttribute('data-aero-selection-chip-' + chipIndex);
          if (!value) {
            return;
          }

          var chip = document.createElement('span');
          chip.className = 'aec-aero-selection-chip';
          chip.textContent = value;
          compareFocusChips.appendChild(chip);
        });
      }

      if (compareFocusLink) {
        compareFocusLink.setAttribute('href', activeCard.getAttribute('data-aero-product-link') || '#products');
      }

      if (compareFocusLinkText) {
        compareFocusLinkText.textContent = activeCard.getAttribute('data-aero-product-cta') || 'View details';
      }
    }

    function updateMobileBuybar(index) {
      if (!mobileBuybar) {
        return;
      }

      var activeCard = getProductCardByIndex(index);
      if (!activeCard) {
        return;
      }

      if (mobileBuybarLabel) {
        mobileBuybarLabel.textContent = activeCard.getAttribute('data-aero-model-eyebrow') || mobileBuybarLabel.textContent;
      }

      if (mobileBuybarTitle) {
        mobileBuybarTitle.textContent = activeCard.getAttribute('data-aero-model-title') || '';
      }

      if (mobileBuybarPrice) {
        mobileBuybarPrice.textContent = activeCard.getAttribute('data-aero-product-price') || '';
      }

      if (mobileBuybarButton) {
        mobileBuybarButton.setAttribute('href', activeCard.getAttribute('data-aero-product-link') || '#');
      }

      if (mobileBuybarButtonText) {
        mobileBuybarButtonText.textContent = activeCard.getAttribute('data-aero-product-cta') || 'View details';
      }
    }

    function scrollSelectorIntoView(index) {
      if (window.innerWidth > 767) {
        return;
      }

      var targets = modelSelectors.concat(compareSelectors).filter(function (item) {
        return Number(item.getAttribute('data-aero-model-index')) === index;
      });

      targets.forEach(function (item) {
        if (typeof item.scrollIntoView === 'function') {
          item.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }
      });
    }

    function scrollActiveCardIntoView(index) {
      if (!productGrid || window.innerWidth > 767) {
        return;
      }

      var activeCard = productCards.find(function (card) {
        return Number(card.getAttribute('data-aero-model-index')) === index;
      });

      if (activeCard && typeof activeCard.scrollIntoView === 'function') {
        activeCard.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      }
    }

    function scrollCompareColumnIntoView(index) {
      if (!compareTable || window.innerWidth > 767) {
        return;
      }

      var headCell = compareTable.querySelector('.aec-aero-compare-head [data-aero-compare-column="' + index + '"]');
      if (headCell && typeof headCell.scrollIntoView === 'function') {
        headCell.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }

    function activateProduct(index, options) {
      var settings = options || {};
      activeProductIndex = index;
      syncSelectorState(index);
      syncProductCardState(index);
      updateSelectionSummary(index);
      updateCompareFocus(index);
      updateMobileBuybar(index);
      setCompareSpotlight(index);

      if (settings.scrollCards !== false) {
        scrollActiveCardIntoView(index);
      }

      if (settings.scrollCompare) {
        scrollCompareColumnIntoView(index);
      }

      if (settings.scrollSelectors !== false) {
        scrollSelectorIntoView(index);
      }
    }

    productCards.forEach(function (card) {
      var compareIndex = Number(card.getAttribute('data-aero-compare-index'));
      var compareTrigger = card.querySelector('.aec-aero-compare-trigger');
      var cardIndex = Number(card.getAttribute('data-aero-model-index'));

      card.addEventListener('mouseenter', function () {
        if (window.innerWidth > 989) {
          setCompareSpotlight(compareIndex);
        }
      });

      card.addEventListener('mouseleave', function () {
        if (window.innerWidth > 989) {
          setCompareSpotlight(activeProductIndex);
        }
      });

      card.addEventListener('focusin', function () {
        activateProduct(cardIndex, { scrollCards: false });
      });

      card.addEventListener('focusout', function () {
        if (card.contains(document.activeElement)) {
          return;
        }

        setCompareSpotlight(activeProductIndex);
      });

      card.addEventListener('click', function (event) {
        if (event.target.closest('a, button')) {
          return;
        }

        activateProduct(cardIndex);
      });

      if (compareTrigger && compareSection) {
        compareTrigger.addEventListener('click', function (event) {
          var href = compareTrigger.getAttribute('href');
          activateProduct(cardIndex, { scrollCompare: true, scrollCards: false });
          compareSection.classList.add('is-jumped-to');

          if (href && href.charAt(0) === '#') {
            event.preventDefault();
            var offset = navShell ? navShell.getBoundingClientRect().height + 18 : 96;
            var targetTop = window.scrollY + compareSection.getBoundingClientRect().top - offset;

            window.scrollTo({
              top: targetTop,
              behavior: 'smooth'
            });
          }

          window.setTimeout(function () {
            compareSection.classList.remove('is-jumped-to');
          }, 1400);
        });
      }
    });

    modelSelectors.forEach(function (selector) {
      selector.addEventListener('click', function () {
        activateProduct(Number(selector.getAttribute('data-aero-model-index')), {
          scrollCards: true,
          scrollCompare: window.innerWidth <= 767
        });
      });
    });

    compareSelectors.forEach(function (selector) {
      selector.addEventListener('click', function () {
        activateProduct(Number(selector.getAttribute('data-aero-model-index')), {
          scrollCards: window.innerWidth <= 767,
          scrollCompare: true
        });
      });
    });

    if (revealTargets.length && 'IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.16,
        rootMargin: '0px 0px -10% 0px'
      });

      revealTargets.forEach(function (target, index) {
        target.classList.add('aec-aero-reveal');
        target.style.setProperty('--aec-reveal-delay', String(index % 4 * 70) + 'ms');
        revealObserver.observe(target);
      });
    } else {
      revealTargets.forEach(function (target) {
        target.classList.add('is-visible');
      });
    }

    if (inViewTargets.length && 'IntersectionObserver' in window) {
      var inViewObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-engaged', entry.isIntersecting);
        });
      }, {
        threshold: 0.35,
        rootMargin: '-10% 0px -10% 0px'
      });

      inViewTargets.forEach(function (target) {
        inViewObserver.observe(target);
      });
    }

    function updateProgress() {
      if (!progressBar) {
        return;
      }

      var scrollTop = window.scrollY || window.pageYOffset;
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var fullHeight = document.documentElement.scrollHeight - viewportHeight;
      var ratio = fullHeight > 0 ? Math.max(0, Math.min(1, scrollTop / fullHeight)) : 0;

      if (navShell) {
        navShell.classList.toggle('is-scrolled', scrollTop > 10);
      }

      progressBar.style.transform = 'scaleX(' + ratio.toFixed(4) + ')';
    }

    function updateActiveNav() {
      if (!navLinks.length || !navTargets.length) {
        return;
      }

      var offset = navShell ? navShell.getBoundingClientRect().height + 32 : 120;
      var activeId = navTargets[0].id;

      navTargets.forEach(function (target) {
        var targetTop = target.getBoundingClientRect().top;
        if (targetTop - offset <= 0) {
          activeId = target.id;
        }
      });

      navLinks.forEach(function (link) {
        var href = link.getAttribute('href');
        var isActive = href === '#' + activeId;
        link.classList.toggle('is-active', isActive);
      });

      if (activeId !== currentActiveId) {
        currentActiveId = activeId;

        var activeLink = navLinks.find(function (link) {
          return link.getAttribute('href') === '#' + activeId;
        });

        if (activeLink && currentLabel) {
          currentLabel.textContent = activeLink.textContent.trim();
        }

        if (activeLink && typeof activeLink.scrollIntoView === 'function') {
          activeLink.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
        }
      }
    }

    navLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') {
          return;
        }

        var target = document.querySelector(href);
        if (!target) {
          return;
        }

        event.preventDefault();
        var offset = navShell ? navShell.getBoundingClientRect().height + 18 : 96;
        var targetTop = window.scrollY + target.getBoundingClientRect().top - offset;

        window.scrollTo({
          top: targetTop,
          behavior: 'smooth'
        });
      });
    });

    faqItems.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) {
          return;
        }

        faqItems.forEach(function (otherItem) {
          if (otherItem !== item) {
            otherItem.open = false;
          }
        });
      });
    });

    if (hero) {
      hero.addEventListener('pointermove', function (event) {
        if (window.innerWidth < 990) {
          hero.style.removeProperty('--aec-hero-tilt-x');
          hero.style.removeProperty('--aec-hero-tilt-y');
          return;
        }

        var rect = hero.getBoundingClientRect();
        var px = (event.clientX - rect.left) / rect.width - 0.5;
        var py = (event.clientY - rect.top) / rect.height - 0.5;

        hero.style.setProperty('--aec-hero-tilt-x', (px * 10).toFixed(2) + 'px');
        hero.style.setProperty('--aec-hero-tilt-y', (py * 14).toFixed(2) + 'px');
      });

      hero.addEventListener('pointerleave', function () {
        hero.style.setProperty('--aec-hero-tilt-x', '0px');
        hero.style.setProperty('--aec-hero-tilt-y', '0px');
      });
    }

    updateProgress();
    updateActiveNav();
    window.addEventListener('scroll', function () {
      updateProgress();
      updateActiveNav();
    }, { passive: true });
    window.addEventListener('resize', function () {
      updateProgress();
      updateActiveNav();
      setCompareSpotlight(activeProductIndex);
    });

    activateProduct(activeProductIndex, { scrollCards: false });
  });
})();
